import type { StackProps } from '@chakra-ui/react';
import { Clipboard, HStack } from '@chakra-ui/react';
import { currentWallet } from '@cronos-app/wallet';
import { Address as GenericAddress } from '@ui/components/Address';
import { CurrentWalletIcon } from '@ui/components/CurrentWalletIcon';
import { MaskIcon } from '@ui/components/MaskIcon';

export const Address = (props: StackProps) => {
  const account = currentWallet.useAccount();

  return (
    <Clipboard.Root timeout={1000} value={account}>
      <Clipboard.Trigger>
        <HStack
          color="text.secondary"
          cursor="pointer"
          textStyle="body2Bold"
          {...props}
        >
          <CurrentWalletIcon boxSize="16px" />
          <GenericAddress
            address={account ?? ''}
            leadingChars={4}
            tailingChars={4}
          />
          <Clipboard.Indicator
            copied={
              <MaskIcon
                icon="url(/masks/check.svg)"
                boxSize="16px"
                bgColor="state.success"
              />
            }
          >
            <MaskIcon icon="url(/masks/copy.svg)" boxSize="16px" />
          </Clipboard.Indicator>
        </HStack>
      </Clipboard.Trigger>
    </Clipboard.Root>
  );
};
